// extracted by mini-css-extract-plugin
export var phone = "_50-0";
export var phoneDragging = "_50-1";